var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cost_send"},[_c('header-back',{attrs:{"title":_vm.sendModalTit},on:{"back":_vm.toBack}}),_c('router-view'),(_vm.showSendBtn)?_c('cube-button',{staticClass:"send_submit_btn",attrs:{"type":"submit","disabled":_vm.disabledSubmit},on:{"click":_vm.sendMaintain}},[_vm._v("\n    "+_vm._s(_vm.sendModalTit)+"\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }